import { render, staticRenderFns } from "./MypageTicketListContainerSection.vue?vue&type=template&id=51d0ce3c&scoped=true"
import script from "./MypageTicketListContainerSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketListContainerSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketListContainerSection.vue?vue&type=style&index=0&id=51d0ce3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0ce3c",
  null
  
)

export default component.exports